export default __webpack_public_path__ + "static/media/pagado.bb3c7f5c.svg";